export const getTime = (timer) => {
  const date = new Date(0)
  date.setSeconds(timer)
  const timeString = date.toISOString().substr(14, 5)
  return timeString
}

export const getUsableLetters = (letters) => {
  return letters.filter((letter) => {
    return letter !== 'Ь' && letter !== 'Ъ' && letter !== 'Ы'
  })
}

export const getUniqueLetters = (letters) => {
  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  }
  return letters.filter(onlyUnique);
}

export const checkLetters = ({ word, letters }) => {
  let userLetters = word.split('')
  let wrongLetter = ''
  
  for (let i = 0; i < userLetters.length; i++) {
    let letter = userLetters[i]
    if (letters.includes(letter)) {
      letters.splice(letters.indexOf(letter), 1)
    } else {
      wrongLetter = letter
      break
    }
  }
  return wrongLetter
}

export const isNewWord = ({ word, wordsList }) => {
  if (!wordsList.includes(word)) {
    return true
  } else {
    return false
  }
}

export const setTheme = ({themes, theme}) => {
  for (let prop in themes) {
    document.documentElement.style.setProperty(prop, themes[prop][theme])
  }
}